(function () {
  'use strict';

  document.querySelectorAll('[data-member-tool]').forEach(function (root) {
    var tool = root.dataset.memberTool;
    var memberId = root.dataset.memberId || 'member';
    var storageKey = 'ccMemberTool:' + tool + ':v1:' + memberId;
    var currentText = '';

    function readStorage() {
      try {
        var raw = window.localStorage.getItem(storageKey);
        return raw ? JSON.parse(raw) : null;
      } catch (error) {
        return null;
      }
    }

    function writeStorage(value) {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(value));
        return true;
      } catch (error) {
        return false;
      }
    }

    function todayValue() {
      var now = new Date();
      var month = String(now.getMonth() + 1).padStart(2, '0');
      var day = String(now.getDate()).padStart(2, '0');
      return now.getFullYear() + '-' + month + '-' + day;
    }

    function formatDate(value) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return value || '';
      return new Date(value + 'T12:00:00').toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    }

    function clamp(value, minimum, maximum) {
      return Math.min(maximum, Math.max(minimum, value));
    }

    function average(values) {
      return values.reduce(function (total, value) { return total + value; }, 0) / values.length;
    }

    function clean(value) {
      return String(value || '').trim();
    }

    function create(tag, text, className) {
      var element = document.createElement(tag);
      if (text !== undefined) element.textContent = text;
      if (className) element.className = className;
      return element;
    }

    function statusLabel(status) {
      if (status === 'green') return 'Green - progressing';
      if (status === 'amber') return 'Amber - adjust and monitor';
      return 'Red - coach input needed';
    }

    function renderStatus(container, status, score) {
      var badge = create('span', statusLabel(status), 'ccm-status ccm-status--' + status);
      var scoreWrap = create('div', undefined, 'ccm-score');
      scoreWrap.append(create('strong', String(score)), create('span', '/ 100'));
      container.append(badge, scoreWrap);
    }

    function setEmailLink(subject, body) {
      var link = root.querySelector('[data-email-result]');
      if (!link) return;
      link.href = 'mailto:info@completecommando.com?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    }

    async function copyText(text, status) {
      if (!text) return;
      try {
        await navigator.clipboard.writeText(text);
        status.textContent = 'Copied. It is ready to send.';
      } catch (error) {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        var copied = document.execCommand('copy');
        textarea.remove();
        status.textContent = copied ? 'Copied. It is ready to send.' : 'Copy was blocked. Use the email button instead.';
      }
    }

    function wireResultActions() {
      var copyButton = root.querySelector('[data-copy-result]');
      var status = root.querySelector('[data-share-status]');
      if (copyButton) {
        copyButton.addEventListener('click', function () {
          copyText(currentText, status);
        });
      }
      var printButton = root.querySelector('[data-print-result]');
      if (printButton) printButton.addEventListener('click', function () { window.print(); });
    }

    function historyRow(date, status, detail) {
      var row = create('div', undefined, 'ccm-history-row');
      row.append(create('span', formatDate(date)), create('strong', status), create('span', detail));
      return row;
    }

    function initWeekly() {
      var form = root.querySelector('[data-weekly-form]');
      var result = root.querySelector('[data-weekly-result]');
      var output = result.querySelector('[data-result-content]');
      var error = form.querySelector('[data-form-error]');
      var historyContainer = root.querySelector('[data-weekly-history]');
      var history = readStorage();
      if (!Array.isArray(history)) history = [];

      form.elements.date.max = todayValue();
      form.elements.date.value = todayValue();

      function weeklyText(entry) {
        return [
          'COMPLETE COMMANDO - WEEKLY COACHING REVIEW',
          'Week ending: ' + formatDate(entry.date),
          'Status: ' + statusLabel(entry.status),
          'Execution score: ' + entry.score + '/100',
          '',
          'PROGRESS',
          entry.progressLabel,
          '',
          'MOST IMPORTANT WIN',
          entry.win,
          '',
          'MAIN FRICTION',
          entry.friction,
          '',
          'TRAINING',
          entry.completed + ' of ' + entry.planned + ' sessions completed',
          'Training quality: ' + entry.training + '/5',
          'Nutrition execution: ' + entry.nutrition + '/5',
          'Sleep quality: ' + entry.sleep + '/5',
          'Energy: ' + entry.energy + '/5',
          'Life pressure: ' + entry.stress + '/5',
          'Pain or injury concern: ' + entry.painLabel,
          '',
          'NEXT-WEEK PRIORITY',
          entry.priority,
          '',
          'COACH SUPPORT NEEDED',
          entry.support,
          '',
          'TOOL DECISION',
          entry.action
        ].join('\n');
      }

      function renderWeekly(entry) {
        output.textContent = '';
        renderStatus(output, entry.status, entry.score);
        output.append(create('h2', entry.title));
        output.append(create('p', entry.action));
        output.append(create('h3', 'Next-week priority'));
        output.append(create('p', entry.priority));
        output.append(create('h3', 'Coach support'));
        output.append(create('p', entry.support));
        currentText = weeklyText(entry);
        setEmailLink('Weekly coaching review - ' + formatDate(entry.date), currentText);
        result.hidden = false;
        result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      function renderHistory() {
        historyContainer.textContent = '';
        if (!history.length) {
          historyContainer.append(create('p', 'Your completed reviews will appear here.', 'ccm-history-empty'));
          return;
        }
        var list = create('div', undefined, 'ccm-history-list');
        history.slice(0, 12).forEach(function (entry) {
          list.append(historyRow(entry.date, entry.status, entry.score + '/100 - ' + entry.priority));
        });
        historyContainer.append(list);
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        error.textContent = '';

        var planned = Number(form.elements.planned.value);
        var completed = Number(form.elements.completed.value);
        var win = clean(form.elements.win.value);
        var friction = clean(form.elements.friction.value);
        var priority = clean(form.elements.priority.value);
        var support = clean(form.elements.support.value);
        var date = form.elements.date.value;

        if (!date || date > todayValue() || !win || !friction || !priority || !support) {
          error.textContent = 'Complete every field and choose a valid week-ending date.';
          return;
        }
        if (!Number.isInteger(planned) || !Number.isInteger(completed) || planned < 0 || completed < 0 || planned > 14 || completed > planned) {
          error.textContent = 'Completed sessions cannot exceed the number planned.';
          return;
        }

        var training = Number(form.elements.training.value);
        var nutrition = Number(form.elements.nutrition.value);
        var sleep = Number(form.elements.sleep.value);
        var energy = Number(form.elements.energy.value);
        var stress = Number(form.elements.stress.value);
        var pain = form.elements.pain.value;
        var completion = planned === 0 ? 1 : completed / planned;
        var wellbeing = average([training, nutrition, sleep, energy, 6 - stress]) / 5;
        var score = Math.round(clamp((wellbeing * 75) + (completion * 25), 0, 100));
        var status = 'green';
        if (pain === 'stop' || score < 50 || sleep === 1 || energy === 1) status = 'red';
        else if (pain === 'monitor' || score < 72 || stress >= 4) status = 'amber';

        var title = status === 'green' ? 'Keep building.' : (status === 'amber' ? 'Narrow the week.' : 'Speak to your coach.');
        var action = status === 'green'
          ? 'Execution and recovery are supporting progress. Keep the structure and make the stated priority the next clear target.'
          : (status === 'amber'
            ? 'Do not add more complexity. Protect the priority, address the main friction and monitor the concern you recorded.'
            : 'Do not force progress through new or worsening pain, very poor recovery or a failing week. Send this review to your coach before increasing load.');
        var progressLabels = { ahead: 'Moved forward', steady: 'Held steady', behind: 'Lost ground' };
        var painLabels = { none: 'None', monitor: 'Present - monitor it', stop: 'New, sharp or worsening' };

        var entry = {
          date: date,
          progressLabel: progressLabels[form.elements.progress.value],
          win: win,
          friction: friction,
          planned: planned,
          completed: completed,
          training: training,
          nutrition: nutrition,
          sleep: sleep,
          energy: energy,
          stress: stress,
          painLabel: painLabels[pain],
          priority: priority,
          support: support,
          score: score,
          status: status,
          title: title,
          action: action
        };

        history = history.filter(function (item) { return item.date !== date; });
        history.unshift(entry);
        history.sort(function (a, b) { return b.date.localeCompare(a.date); });
        history = history.slice(0, 12);
        writeStorage(history);
        renderWeekly(entry);
        renderHistory();
      });

      renderHistory();
      wireResultActions();
    }

    function initRecovery() {
      var form = root.querySelector('[data-recovery-form]');
      var result = root.querySelector('[data-recovery-result]');
      var output = result.querySelector('[data-result-content]');
      var error = form.querySelector('[data-form-error]');
      var historyContainer = root.querySelector('[data-recovery-history]');
      var history = readStorage();
      if (!Array.isArray(history)) history = [];

      form.elements.date.max = todayValue();
      form.elements.date.value = todayValue();

      function recoveryText(entry) {
        return [
          'COMPLETE COMMANDO - RECOVERY & READINESS',
          'Date: ' + formatDate(entry.date),
          'Status: ' + statusLabel(entry.status),
          'Readiness score: ' + entry.score + '/100',
          'Planned session: ' + entry.sessionLabel,
          '',
          'INPUTS',
          'Sleep: ' + entry.hours + ' hours; quality ' + entry.sleep + '/5',
          'Energy: ' + entry.energy + '/5',
          'Motivation: ' + entry.motivation + '/5',
          'Soreness: ' + entry.soreness + '/5',
          'Life pressure: ' + entry.stress + '/5',
          'Pain: ' + entry.painLabel,
          'Illness: ' + entry.illnessLabel,
          '',
          'DECISION',
          entry.action,
          '',
          'This is coaching decision support, not medical diagnosis.'
        ].join('\n');
      }

      function renderRecovery(entry) {
        output.textContent = '';
        renderStatus(output, entry.status, entry.score);
        output.append(create('h2', entry.title));
        output.append(create('p', entry.action));
        var list = create('ul');
        entry.nextSteps.forEach(function (step) { list.append(create('li', step)); });
        output.append(list);
        currentText = recoveryText(entry);
        setEmailLink('Recovery check - ' + formatDate(entry.date), currentText);
        result.hidden = false;
        result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      function renderHistory() {
        historyContainer.textContent = '';
        if (!history.length) {
          historyContainer.append(create('p', 'Your recent checks will appear here.', 'ccm-history-empty'));
          return;
        }
        var list = create('div', undefined, 'ccm-history-list');
        history.slice(0, 14).forEach(function (entry) {
          list.append(historyRow(entry.date, entry.status, entry.score + '/100 - ' + entry.title));
        });
        historyContainer.append(list);
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        error.textContent = '';

        var date = form.elements.date.value;
        var hours = Number(form.elements.hours.value);
        if (!date || date > todayValue() || !Number.isFinite(hours) || hours < 0 || hours > 14) {
          error.textContent = 'Enter a valid date and sleep duration.';
          return;
        }

        var sleep = Number(form.elements.sleep.value);
        var energy = Number(form.elements.energy.value);
        var motivation = Number(form.elements.motivation.value);
        var soreness = Number(form.elements.soreness.value);
        var stress = Number(form.elements.stress.value);
        var pain = form.elements.pain.value;
        var illness = form.elements.illness.value;
        var session = form.elements.session.value;
        var sleepDurationScore = clamp(((hours - 4) / 4.5) * 100, 0, 100);
        var subjectiveScore = average([sleep, energy, motivation, 6 - soreness, 6 - stress]) / 5 * 100;
        var score = Math.round((sleepDurationScore * .3) + (subjectiveScore * .7));
        var status = 'green';

        if (pain === 'stop' || illness === 'systemic') status = 'red';
        else if (illness === 'mild' || pain === 'known' || score < 70 || hours < 6) status = 'amber';
        if (score < 50) status = 'red';

        var title;
        var action;
        var nextSteps;
        if (status === 'green') {
          title = 'Train as planned.';
          action = 'The current signals support the planned session. Use the warm-up as the final check and keep the prescribed intent.';
          nextSteps = ['Fuel and hydrate for the session.', 'Reassess if the warm-up feels materially worse than this check.', 'Do not turn a good day into unplanned extra volume.'];
        } else if (status === 'amber') {
          title = 'Modify, then monitor.';
          action = session === 'hard' || session === 'strength'
            ? 'Keep the session controlled. Extend the warm-up and reduce volume or intensity if readiness does not improve.'
            : 'Keep the easy or technical intent. Do not convert it into a hard session.';
          nextSteps = ['Remove non-essential volume.', 'Prioritise food, fluids and an earlier night.', 'Tell your coach if this pattern repeats or symptoms worsen.'];
        } else {
          title = 'Do not force the session.';
          action = 'The combination of recovery signals or a pain/illness flag needs a more cautious decision. Send this result to your coach before hard training.';
          nextSteps = ['Do not train through new, sharp or worsening pain.', 'Seek appropriate medical care for concerning or systemic symptoms.', 'Use rest or only coach-approved low-demand work.'];
        }

        var sessionLabels = { hard: 'Hard conditioning', strength: 'Heavy strength', easy: 'Easy or technical', rest: 'Rest day' };
        var painLabels = { none: 'None', known: 'Known and managed', stop: 'New, sharp or worsening' };
        var illnessLabels = { none: 'None', mild: 'Mild symptoms', systemic: 'Fever, chest or systemic symptoms' };
        var entry = {
          date: date,
          hours: hours,
          sleep: sleep,
          energy: energy,
          motivation: motivation,
          soreness: soreness,
          stress: stress,
          painLabel: painLabels[pain],
          illnessLabel: illnessLabels[illness],
          sessionLabel: sessionLabels[session],
          score: score,
          status: status,
          title: title,
          action: action,
          nextSteps: nextSteps
        };

        history = history.filter(function (item) { return item.date !== date; });
        history.unshift(entry);
        history.sort(function (a, b) { return b.date.localeCompare(a.date); });
        history = history.slice(0, 14);
        writeStorage(history);
        renderRecovery(entry);
        renderHistory();
      });

      renderHistory();
      wireResultActions();
    }

    function initMission() {
      var form = root.querySelector('[data-mission-form]');
      var result = root.querySelector('[data-mission-result]');
      var output = result.querySelector('[data-result-content]');
      var error = form.querySelector('[data-form-error]');
      var saved = readStorage();

      form.elements.deadline.min = todayValue();

      function missionText(entry) {
        return [
          'COMPLETE COMMANDO - 12-WEEK MISSION ORDER',
          'Target date: ' + formatDate(entry.deadline),
          '',
          'OUTCOME',
          entry.outcome,
          '',
          'PROOF',
          entry.proof,
          '',
          'WHY IT MATTERS',
          entry.why,
          '',
          'WEEKLY STANDARD',
          '1. ' + entry.actionOne,
          '2. ' + entry.actionTwo,
          '3. ' + entry.actionThree,
          '',
          'MINIMUM ON A BAD WEEK',
          entry.minimum,
          '',
          'IF-THEN PLAN',
          'If ' + entry.trigger + ', then I will ' + entry.response + '.',
          '',
          'FIRST ACTION IN 24 HOURS',
          entry.firstAction
        ].join('\n');
      }

      function renderMission(entry, shouldScroll) {
        output.textContent = '';
        output.append(create('h2', entry.outcome));
        output.append(create('p', 'Target: ' + formatDate(entry.deadline) + ' | Proof: ' + entry.proof));
        output.append(create('h3', 'Why it matters'));
        output.append(create('p', entry.why));
        output.append(create('h3', 'Weekly standard'));
        var actions = create('ol');
        [entry.actionOne, entry.actionTwo, entry.actionThree].forEach(function (action) { actions.append(create('li', action)); });
        output.append(actions);
        output.append(create('h3', 'Minimum on a bad week'));
        output.append(create('p', entry.minimum));
        output.append(create('h3', 'If-then plan'));
        output.append(create('p', 'If ' + entry.trigger + ', then I will ' + entry.response + '.'));
        output.append(create('h3', 'First action'));
        output.append(create('p', entry.firstAction));
        currentText = missionText(entry);
        setEmailLink('12-week mission order - ' + formatDate(entry.deadline), currentText);
        result.hidden = false;
        if (shouldScroll) result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        error.textContent = '';
        var fields = ['outcome', 'deadline', 'proof', 'why', 'actionOne', 'actionTwo', 'actionThree', 'minimum', 'trigger', 'response', 'firstAction'];
        var entry = {};
        var complete = fields.every(function (name) {
          entry[name] = clean(form.elements[name].value);
          return entry[name] !== '';
        });
        if (!complete || entry.deadline < todayValue()) {
          error.textContent = 'Complete every field and choose today or a future target date.';
          return;
        }
        writeStorage(entry);
        renderMission(entry, true);
      });

      if (saved && !Array.isArray(saved)) {
        Object.keys(saved).forEach(function (name) {
          if (form.elements[name]) form.elements[name].value = saved[name];
        });
        renderMission(saved, false);
      }
      wireResultActions();
    }

    if (tool === 'weekly') initWeekly();
    else if (tool === 'recovery') initRecovery();
    else if (tool === 'mission') initMission();
  });
})();
